import { useCallback, useEffect, useRef, useState } from "react";

export default function useTTS(enabled) {
    const [supported, setSupported] = useState(false);
    const lastUtter = useRef(null);

    useEffect(() => {
        if (typeof window !== "undefined" && "speechSynthesis" in window) {
            setSupported(true);
        }
    }, []);

    const speak = useCallback((text) => {
        if (!enabled || !supported || !text) return;
        try {
            window.speechSynthesis.cancel();
            const u = new SpeechSynthesisUtterance(String(text));
            u.rate = 1.0;
            u.pitch = 0.85;
            u.volume = 1.0;
            lastUtter.current = u;
            window.speechSynthesis.speak(u);
        } catch (e) {
            console.warn("TTS speak failed:", e?.message || e);
        }
    }, [enabled, supported]);

    const stop = useCallback(() => {
        if (!supported) return;
        try {
            window.speechSynthesis.cancel();
        } catch (e) {
            console.warn("TTS cancel failed:", e?.message || e);
        }
    }, [supported]);

    useEffect(() => {
        return () => { stop(); };
    }, [stop]);

    return { speak, stop, supported };
}
